<template lang="pug">
.error-overlay(:class="showErrorOverlay ? '' : 'hide'")
  Common.system-error(title='A system error occurred' :errors='errors')
    h1(slot='header') {{ errorText }}

    main(slot='main' v-touch:touchhold="touchHandler")
      p Please&nbsp;
        a(:href='mailto') click here
        | &nbsp;to send us an email {{ reportingId ? "with the problem id (" + reportingId + ")": "" }} and any further information you think might be helpful to us, such as what you were doing when the error occurred.

      .reload 
        p Try reloading the app now or in a while in case this is an temporary error.
        button(v-if="reload" @click="reloadPage") Click here to reload the app

      .errors(v-if="showErrors") 
        ul(v-for="error in resolvedErrors")
          li
            h3 {{ error.message }}
            .code
              code {{ error.detail }}
</template>

<script>
import { Common } from "AccountPages/components";
import "./scss";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";

export default {
  name: "SystemError",
  components: {
    Common,
  },
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
    reload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      systemErrorEvent: undefined,
      errorText: "Sorry, something went wrong...",
      showErrors: false,
    };
  },
  computed: {
    mailto() {
      const subject = `SaveTrees problem report${this.reportingId ? ": " + this.reportingId : ""}`;
      let body = "[[Please fill in any further information here]]%0D%0A%0D%0AThanks";
      body += "%0D%0A%0D%0A%0D%0ATechnical info:%0D%0A%0D%0A" + (this.reportingId ? "Reporting id: " + this.reportingId + "%0D%0A" : "");
      body += `Date: ${new Date()} %0D%0AURL: ${location.href} %0D%0A`;
      body += JSON.stringify(this.systemErrorData, null, 2);
      const mailto = `mailto:feedback@savetrees.co.uk?Subject=${subject}&body=${body}`;

      return mailto;
    },
    reportingId() {
      return this.systemError && this.systemErrorEvent.data.reportingId;
    },
    systemErrorData() {
      return this.systemError && this.systemErrorEvent.error;
    },
    showErrorOverlay() {
      return this.systemError && this.systemError.showErrorOverlay;
    },
    systemError() {
      return this.systemErrorEvent && this.systemErrorEvent.data;
    },
    resolvedErrors() {
      const errors = this.errors.slice();
      if (this.$app.SystemErrorEvent) {
        errors.unshift(this.$app.SystemErrorEvent);
      }

      const resolvedErrors = errors.map(error => {
        const resolvedError = error instanceof this.$Events.SystemErrorEvent ? error.data.error : error;
        const errorData = {
          message: resolvedError.message,
          detail: JSON.stringify(
            {
              id: resolvedError.id,
              stack: resolvedError.stack,
              data: resolvedError.data,
            },
            null,
            2
          ),
        };

        return errorData;
      });

      return resolvedErrors;
    },
  },
  created() {
    WebApplicationConstants.listenerEventBuses.system.on(this.$Events.SystemErrorEvent.Type, systemErrorEvent => (this.systemErrorEvent = systemErrorEvent), this);
    window.addEventListener("keydown", e => {
      if (e.key == "Escape") {
        this.showErrors = !this.showErrors;
      }
    });
  },
  methods: {
    reloadPage() {
      window.location.assign("/");
    },
    touchHandler() {
      this.showErrors = !this.showErrors;
    },
  },
};
</script>
